import React, { useMemo } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Workspace from "react-material-workspace-layout/Workspace";
export default (function (_ref) {
  var children = _ref.children,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      _ref$currentSampleInd = _ref.currentSampleIndex,
      currentSampleIndex = _ref$currentSampleInd === void 0 ? 0 : _ref$currentSampleInd,
      _ref$numberOfSamples = _ref.numberOfSamples,
      numberOfSamples = _ref$numberOfSamples === void 0 ? 1 : _ref$numberOfSamples,
      titleContent = _ref.titleContent,
      onClickHeaderItem = _ref.onClickHeaderItem;
  var headerItems = useMemo(function () {
    return [(currentSampleIndex > 0 || onPrev) && {
      name: "Prev",
      onClick: onPrev
    }, (numberOfSamples > currentSampleIndex + 1 || onNext) && {
      name: "Next",
      onClick: onNext
    }, {
      name: "Save"
    }].filter(Boolean);
  }, [currentSampleIndex, numberOfSamples]);
  return /*#__PURE__*/React.createElement(Workspace, {
    headerLeftSide: titleContent === undefined ? /*#__PURE__*/React.createElement(Box, {
      paddingLeft: 2,
      fontWeight: "bold"
    }, /*#__PURE__*/React.createElement(Typography, null, "Sample ", currentSampleIndex + 1, " / ", numberOfSamples)) : titleContent,
    onClickHeaderItem: onClickHeaderItem,
    headerItems: headerItems,
    iconSidebarItems: [],
    rightSidebarItems: []
  }, /*#__PURE__*/React.createElement(Box, {
    padding: 2
  }, children));
});